import { ILayer, IMarker } from '../../../types/common';

const source = 'trapHistory';

const config = {
  id: source,
  type: 'fill',
  source,
  layout: {
    visibility: 'visible',
  },
  paint: {
    'fill-color': '#CCC',
    'fill-opacity': 0.3,
    'fill-outline-color': '#FFF',
  },
};

const load = async ({
  courseId = null,
  predatorTypes = null,
  startDate = null,
  endDate = null,
}): Promise<ILayer> => {
  const params = [
    courseId ? `course_id=${courseId}` : null,
    predatorTypes ? `predator_types=${predatorTypes}` : null,
    startDate ? `start_date=${startDate}` : null,
    endDate ? `end_date=${endDate}` : null,
  ]
    .filter(Boolean)
    .join('&');
  const response = await fetch(`/geojson/trap_history?${params}`);
  const data = await response.json();
  const items: IMarker[] = data.features.map(
    (item) =>
      ({
        ...item,
        id: item.properties.trap_number,
        type: 'trap',
        coordinates: item.geometry.coordinates,
        course: item.properties.course,
        lastUpdateDate: item.properties.last_update_date,
        plantation: item.properties.plantation,
        predatorsTrapped: item.properties.predators_trapped,
        successRate: +item.properties.success_rate,
        trapId: item.properties.trap_id,
        trapNumber: item.properties.trap_number,
        trapUpdateDates: item.properties.trap_update_dates,
        courseId: item.properties.course_id,
      } as IMarker),
  );

  return {
    data,
    config,
    source,
    labels: null,
    markers: {
      type: 'hunt',
      items,
    },
  };
};

export default load;
